/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderItem {
  cst?: string;
  defaultImage?: string;
  invoiceName?: string;
  invoicePrice?: number;
  ncm?: string;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  rewardId?: number;
  salePrice?: number;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  stockout?: boolean;
  taxTemplateItemId?: number;
  unitMeasure?: number;
  unitName?: string;
  weight?: number;
}
